/* DNA homepage v2 behaviours: spotlight colour chips + theme-editor re-init. */
(function(){
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}

  // ----- product spotlight: swap image / price / add-to-cart id when a chip is clicked
  function mountSpotlight(sec){
    var chips=$$('.spot-chip',sec); if(!chips.length) return;
    var img=sec.querySelector('.spot-art img'), price=sec.querySelector('.spot-price b'),
        cmp=sec.querySelector('.spot-price s'), buy=sec.querySelector('.spot-acts .buy'),
        more=sec.querySelector('.spot-acts .more'), title=sec.querySelector('.spot-copy h2[data-auto]');
    chips.forEach(function(ch){
      ch.addEventListener('click',function(e){
        e.preventDefault();
        chips.forEach(function(c){c.classList.remove('on');}); ch.classList.add('on');
        var d=ch.dataset;
        if(img&&d.img&&img.getAttribute('src')!==d.img){
          img.classList.add('swap');
          var pre=new Image(); pre.onload=function(){img.src=d.img;img.classList.remove('swap');}; pre.src=d.img;
        }
        if(price&&d.price) price.innerHTML='<small>JOD </small>'+d.price;
        if(cmp){ if(d.compare){cmp.textContent=d.compare;cmp.hidden=false;} else {cmp.hidden=true;} }
        if(buy&&d.variant) buy.setAttribute('data-add',d.variant);
        if(more&&d.url) more.setAttribute('href',d.url);
        if(title&&d.title) title.textContent=d.title;
      });
    });
  }

  function init(root){
    $$('.spot',root).forEach(mountSpotlight);
    if(window.dnaRailArrows) window.dnaRailArrows();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);

  // Theme editor: sections re-render on every setting change
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

/* ===== endless product feed: Section Rendering API + IntersectionObserver ===== */
(function(){
  function mountFeed(sec){
    if(sec._feed) return; sec._feed=1;
    var grid=sec.querySelector('.feed-grid'), more=sec.querySelector('.feed-more'), auto=sec.dataset.auto==='true', max=parseInt(sec.dataset.max)||8, busy=false;
    function btn(){return sec.querySelector('.feedmore');}
    function load(){
      var b=btn(); if(!b||busy) return; var page=parseInt(b.dataset.page); if(page>max){b.remove();return;}
      busy=true; b.classList.add('loading');
      var url=location.pathname+'?section_id='+sec.dataset.section+'&page='+page;
      fetch(url).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var w=window.dnaGetWish?window.dnaGetWish():[];
        doc.querySelectorAll('.feed-grid > *').forEach(function(c){
          var n=document.importNode(c,true); grid.appendChild(n);
          if(window.dnaSlider) window.dnaSlider(n);
          var wb=n.querySelector('[data-wish]'); if(wb&&w.indexOf(wb.dataset.wish)>-1) wb.classList.add('on');
        });
        var nm=doc.querySelector('.feed-more'); if(nm){more.innerHTML=nm.innerHTML;} else {b.remove();}
        busy=false; var nb=btn(); if(nb&&parseInt(nb.dataset.page)>max) nb.remove();
      }).catch(function(){busy=false; var b2=btn(); if(b2) b2.classList.remove('loading');});
    }
    sec.addEventListener('click',function(e){ if(e.target.closest('.feedmore')){e.preventDefault();load();} });
    if(auto&&'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting) load(); }); },{rootMargin:'600px 0px'});
      io.observe(more);
    }
  }
  function init(root){ Array.prototype.forEach.call((root||document).querySelectorAll('[data-feed]'),mountFeed); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document);}); else init(document);
  document.addEventListener('shopify:section:load',function(e){ init(e.target); });
})();

/* ===== collection pages: load the next page automatically when the button scrolls into view ===== */
(function(){
  var btn=document.querySelector('.plp-main .loadmore'); if(!btn||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting&&!btn._busy&&document.contains(btn)) btn.click(); }); },{rootMargin:'700px 0px'});
  io.observe(btn);
})();
